import { ArrowUpRight, Compass } from "lucide-react";
import { SidebarTrigger } from "../ui/sidebar";
import { RescueRoomTools } from "./RescueRoomControls";

type Props = {
  caseCount: number;
  showTools: boolean;
  totalLabel: string;
  onAnalyze: () => void;
};

export function RescueRoomHeader({
  caseCount,
  showTools,
  totalLabel,
  onAnalyze,
}: Props) {
  return (
    <header className="flex flex-col gap-6 pb-2 sm:pb-4">
      <div className="flex items-center justify-between gap-3">
        <div className="flex min-w-0 items-center gap-3">
          <SidebarTrigger />
          <span className="h-4 w-px bg-border" aria-hidden="true" />
          <p className="flex items-center gap-2 text-xs font-medium text-muted-foreground">
            <Compass
              className="h-4 w-4 text-orange-700 dark:text-orange-300"
              aria-hidden="true"
            />
            Rescue Room
          </p>
        </div>
        {showTools ? (
          <RescueRoomTools totalLabel={totalLabel} onAnalyze={onAnalyze} />
        ) : null}
      </div>
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h1 className="text-3xl font-semibold tracking-[-0.04em] sm:text-4xl">
            Your customer briefing
            <span
              aria-hidden="true"
              className="text-orange-600 dark:text-orange-400"
            >
              .
            </span>
          </h1>
          <p className="mt-3 max-w-xl text-sm leading-6 text-muted-foreground">
            The context. The evidence. Your next move.
          </p>
        </div>
        {showTools ? (
          <p className="flex items-center gap-2 text-xs text-muted-foreground">
            <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
            {caseCount} customer {caseCount === 1 ? "case" : "cases"} to explore
          </p>
        ) : null}
      </div>
    </header>
  );
}
